import { gql } from "@apollo/client";

export const PRINT_FORM3457B = gql`
  mutation printStudentForm3457B(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
    $formDate: String
    $studentFullName: String
    $studentDob: String
    $parent1: String
    $parent2: String
    $guardianInitialEvaluationConsent: String
    $signatureDate: String
    $formAction: String
$formStatus: String
  ) {
    printStudentForm3457B(
      studentForm3457BInput: {
        studentFormId: $studentFormId
        formId: $formId
        studentId: $studentId
        schoolId: $schoolId
        studentMeetingId: $studentMeetingId
        formDate: $formDate
        studentFullName: $studentFullName
        studentDob: $studentDob
        parent1: $parent1
        parent2: $parent2
        guardianInitialEvaluationConsent: $guardianInitialEvaluationConsent
        signatureDate: $signatureDate
formAction: $formAction
formStatus: $formStatus
      }
    ) {
      link
      fileName
    }
  }
`;
